import { render, staticRenderFns } from "./OrganizationCreate.vue?vue&type=template&id=a623ab70"
import script from "./OrganizationCreate.vue?vue&type=script&lang=js"
export * from "./OrganizationCreate.vue?vue&type=script&lang=js"
import style0 from "./OrganizationCreate.vue?vue&type=style&index=0&id=a623ab70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports